import { useRouter } from 'next/router';

import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MainLayout from '@/src/layouts/MainLayout';
import { blogCategoryByUIDGet, blogPostsByCategoryIDGet } from '@/src/lib/prismic/queries';
import { urlHostResolver } from '@/src/lib/utils';
import BlogCategory from '@/src/views/blog/BlogCategory';

export default function BlogCategoryPage({ doc, preview }) {
  const router = useRouter();
  const { categoryUid } = router.query;

  return (
    <AssembleLayout Layout={MainLayout} Component={BlogCategory} doc={doc} preview={preview}>
      <NextSeo
        title={`${doc?.category?.data?.name} | Blog`}
        description="Acompanhe artigos escritos especialmente para escolas, parceiros, famílias e qualquer pessoa interessada no futuro da educação."
        openGraph={{
          title: `${doc?.category?.data?.name} | Blog`,
          url: urlHostResolver(`/blog/category/${categoryUid}`),
          images: [
            {
              url: urlHostResolver(`/images/illustrations/blog.png`),
              width: 1125,
              height: 571,
              alt: 'Blog',
            },
          ],
        }}
      />
    </AssembleLayout>
  );
}

BlogCategoryPage.propTypes = {
  doc: PropTypes.object,
  preview: PropTypes.bool,
};

export async function getStaticPaths() {
  return { paths: [], fallback: 'blocking' };
}

export async function getStaticProps(context) {
  const { params, preview = false, previewData = {} } = context;
  const { ref } = previewData;
  const { categoryUid } = params;

  const category = await blogCategoryByUIDGet({ categoryUid });

  if (!category) return { notFound: true };

  const graphQuery = `{
    blog-post {
      cover
      title
      description
      date
      author {
        name
        avatar
      }
    }
  }`;

  const { id: categoryId } = category;

  const posts = await blogPostsByCategoryIDGet({ categoryId, graphQuery }, { ref });

  return {
    props: { doc: { category, posts }, preview },
    revalidate: 180,
  };
}
